import type { FC } from "react";
import type { PlainWorkflowExecutionAction } from "@/queries/automation-queries";
import { WorkflowExecutionActionStepCard } from "@/components/automations/AutomationExecutionActionStepCard";

export const WorkflowExecutionActionStepList: FC<{ action: PlainWorkflowExecutionAction }> = ({ action }) => {
    return (
        <div className="flex flex-col gap-2">
            {action.status?.stepStatuses.map((step) => (
                <WorkflowExecutionActionStepCard key={step.stepIndex} step={step} />
            ))}
        </div>
    );
};
